var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.close),expression:"close"}],staticClass:"suggestion-root shadow"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }